var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCombine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "6.552 7.292 16.002 15.979"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.05 14.27h4.5c.55 0 .69-.32.29-.71L19.26 12l3.15-3.15a.51.51 0 0 0 0-.71l-.71-.7a.5.5 0 0 0-.71 0l-3.15 3.14L16.26 9c-.39-.39-.71-.26-.71.29v4.5a.5.5 0 0 0 .5.48M7.41 23.12a.48.48 0 0 0 .7 0L11.26 20l1.58 1.58c.4.39.71.26.71-.29v-4.5a.5.5 0 0 0-.5-.5h-4.5c-.55 0-.68.32-.29.71l1.58 1.58-3.14 3.13a.5.5 0 0 0 0 .71Z"
})));
export default SvgCombine;